export default (search) => {
  return new RegExp(`${search||''}`.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
}